import React from "react";

const SvgEye = props => (
  <svg
    style={{
      isolation: "isolate"
    }}
    viewBox="0 0 205 200"
    {...props}
  >
    <defs>
      <clipPath id="Eye_svg__a">
        <path d="M0 0h205v200H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#Eye_svg__a)">
      <circle
        cx={68.43}
        cy={70.43}
        r={19.4}
        fill="#FFF"
        strokeWidth={4}
        stroke="#1D1D1B"
        strokeMiterlimit={10}
      />
    </g>
  </svg>
);

export default SvgEye;